function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64",
  height: "64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.334 23.267c0-12.126 9.837-21.934 22-21.934 12.162 0 22 9.808 22 21.934 0 16.45-22 40.733-22 40.733s-22-24.283-22-40.733z",
  fill: "#eb1700"
}), /*#__PURE__*/React.createElement("rect", {
  x: "14.666",
  y: "6.667",
  width: "33.333",
  height: "33.333",
  rx: "16.667",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.583 13.583v19.493h1.5V15.083h11.25v17.993l6.75.007V19.966h-5.25v-6.383zm15.75 15.195h1.493v2.055h-1.493zm0-3.57h1.493v2.055h-1.493zm0-3.562h1.493V23.7h-1.493zm-7.875 0h-1.5V23.7h1.493v-2.055zm0-5.25h-1.5v4.125h1.493v-4.125zm1.313 2.805v-1.493h-4.125v1.493zm-3.938 2.445h-1.5V23.7h1.5zm5.25 0h-1.5V23.7h1.5zm-2.625 3.562h-1.5v2.055h1.493v-2.055zm-2.625 0h-1.5v2.055h1.5zm5.25 0h-1.5v2.055h1.5zm-2.625 3.57h-1.5v2.055h1.493v-2.055zm-2.625 0h-1.5v2.055h1.5zm5.25 0h-1.5v2.055h1.5z",
  fill: "#eb1700"
})));